import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class FeedbackToSlackId extends IdValueObject {
  static create(value: string): FeedbackToSlackId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new FeedbackToSlackId(value);
  }
}
